import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4468b978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = { class: "warning" }
const _hoisted_3 = { class: "rate-wrap" }
const _hoisted_4 = { class: "tip" }
const _hoisted_5 = { class: "message-wrap van-hairline--top" }
const _hoisted_6 = { class: "message-label" }
const _hoisted_7 = { key: 0 }

import { withDefaults, computed, watch } from 'vue'
import PopupWrap from '@/components/popup/common-wrap.vue'
import { ref } from 'vue'
import { Rate, Field, Toast } from 'vant'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import { getTicketDetail, setTicketEvaluation } from '@/apis/complete-machine-delivery'
import { commonErrorHandle } from '@/utils/error-handle'
import { showToastLoading, clearToast } from '@/utils/tools'
import appHost from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'evaluate-popup',
  props: {
    show: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    guid: { default: '' },
    order_no: { default: '' },
    assess_info: null
  },
  emits: ['update:show', 'success'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { show: boolean, isEdit: boolean, guid: string, order_no: string, assess_info?: {
      score: string
      explain: string
    } };




expose({
  initData,
})

let rateMap = {
  1: '非常不满意',
  2: '不满意',
  3: '一般',
  4: '满意',
  5: '非常满意',
}

let formData = ref({
  rate: 0,
  message: '',
})

let rateTip = computed(() => {
  return rateMap[formData.value.rate] || ''
})
function updateShowHandle(value: boolean) {
  emits('update:show', value)
}

async function initData() {
  console.log('initData', props.isEdit, props.assess_info)
  if (!props.isEdit && props.assess_info) {
    formData.value.rate = Number(props.assess_info.score)
    formData.value.message = props.assess_info.explain
  }
}

async function confirmHandle() {
  console.log('props.isEdit', props.isEdit)
  if (!props.isEdit) {
    emits('update:show', false)
    return
  }
  if (!formData.value.rate) {
    Toast('请对服务进行评分')
    return
  }

  try {
    showToastLoading()
    await setTicketEvaluation({
      order_no: props.order_no as string,
      score: String(formData.value.rate),
      explain: formData.value.message,
    })
    Toast.success('评价成功！')
    emits('update:show', false)
    emits('success')
  } catch (e) {
    commonErrorHandle(e)
  }
  clearToast()
}

function phoneHandle() {
  appHost.postCallPhone('400-780-3131')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createBlock(PopupWrap, {
    title: props.isEdit ? '服务评价' : '查看评价',
    show: props.show,
    teleport: "body",
    "onUpdate:show": updateShowHandle,
    style: { background: '#fff' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_icon, { name: "phone-o" }),
          _createElementVNode("div", null, [
            _createTextVNode(" 请您服务评价，48小时内将进行电话回访，请保存"),
            _createElementVNode("span", {
              class: "phone-number",
              onClick: phoneHandle
            }, "400-780-3131"),
            _createTextVNode(" 来电，以免错过。 ")
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Rate), {
            modelValue: _unref(formData).rate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).rate) = $event)),
            size: 50,
            color: "#ffd21e",
            "void-icon": "star",
            "void-color": "#eee",
            disabled: !props.isEdit
          }, null, 8, ["modelValue", "disabled"]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(rateTip)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode("建议与反馈 "),
            (props.isEdit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "（非必填）"))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(Field), {
            modelValue: _unref(formData).message,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).message) = $event)),
            autosize: "",
            class: "message-input",
            type: "textarea",
            placeholder: props.isEdit ? '请输入留言' : '',
            disabled: !props.isEdit
          }, null, 8, ["modelValue", "placeholder", "disabled"])
        ])
      ]),
      (props.isEdit)
        ? (_openBlock(), _createBlock(CommonFooterNextButton, {
            key: 0,
            class: "footer-button-wrap",
            title: "确定",
            onClick: confirmHandle
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "show"]))
}
}

})